<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Config'|translate }}
                </v-card-title>
                <v-card-actions>
                    <span style="width:300px;"><v-text-field class="ml-2" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-spacer></v-spacer>

                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Config')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <v-btn class="accent" v-if="siteConfigChildren&&!syncInProgress" @click="syncDialog=true">
                        <v-icon small class="mr-2">fa-sitemap</v-icon>
                        {{ 'Sync config to child sites'|translate }}
                    </v-btn>
                    <v-btn class="accent" v-if="siteConfigMaster&&!syncInProgress" @click="syncFromMasterDialog=true">
                        <v-icon small class="mr-2">fa-download</v-icon>
                        {{ 'Sync config from master'|translate }}
                    </v-btn>
                    <v-btn class="accent" v-if="!syncInProgress" @click="exportAllConfig">
                        <v-icon small class="mr-2">fa-file-download</v-icon>
                        {{ 'Export all config'|translate }}
                    </v-btn>
                    <v-btn class="accent mr-2" v-if="!syncInProgress" @click="syncFromFileJSON=''; syncFromFileDialog=true">
                        <v-icon small class="mr-2">fa-file-upload</v-icon>
                        {{ 'Import config from JSON'|translate }}
                    </v-btn>
                    <config-record-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></config-record-dialog>
                    <v-dialog v-model="syncDialog" max-width="800" persistent>
                        <v-card v-if="syncDialog">
                            <v-card-title class="primary white--text title">
                                {{ 'Sync config to child sites'|translate }}
                            </v-card-title>
                            <v-card-text>
                                <h4 class="text-center" v-if="syncInProgress">{{ 'Sync in progress. Do not close this window.'|translate }}</h4>
                                <v-select v-if="!syncInProgress" multiple v-model="thingsToSync" :items="possibleThingsToSync" :label="'Configs to sync'|translate"></v-select>
                                <v-progress-linear v-if="syncInProgress" :value="syncProgress"></v-progress-linear>
                                <p v-if="syncInProgress" class="text-center">{{ syncMessage }}</p>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn outline class="ml-2" @click="syncDialog=false" :disabled="syncInProgress">{{ 'Cancel'|translate }}</v-btn>
                                <v-btn class="primary mr-2 elevation-4" :disabled="thingsToSync.length<1||syncInProgress" @click="runSyncToChildren">
                                    {{ 'Sync to all children'|translate }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="syncFromMasterDialog" max-width="800" persistent>
                        <v-card v-if="syncFromMasterDialog">
                            <v-card-title class="primary white--text title">
                                {{ 'Sync config from master'|translate }}
                            </v-card-title>
                            <v-card-text>
                                <h4 class="text-center" v-if="syncInProgress">{{ 'Sync in progress. Do not close this window.'|translate }}</h4>
                                <v-select v-if="!syncInProgress" multiple v-model="thingsToSync" :items="possibleThingsToSync" :label="'Configs to sync'|translate"></v-select>
                                <v-progress-linear v-if="syncInProgress" :value="syncProgress"></v-progress-linear>
                                <p v-if="syncInProgress" class="text-center">{{ syncMessage }}</p>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn outline class="ml-2"  @click="syncFromMasterDialog=false" :disabled="syncInProgress">{{ 'Cancel'|translate }}</v-btn>
                                <v-btn class="primary mr-2 elevation-4" :disabled="thingsToSync.length<1||syncInProgress" @click="runSyncFromMaster">
                                    {{ 'Sync from master'|translate }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="syncFromFileDialog" max-width="800" persistent>
                        <v-card v-if="syncFromFileDialog">
                            <v-card-title class="primary white--text title">
                                {{ 'Import config from JSON'|translate }}
                            </v-card-title>
                            <v-card-text>
                                <h4 class="text-center" v-if="syncInProgress">{{ 'Sync in progress. Do not close this window.'|translate }}</h4>
                                <v-select v-if="!syncInProgress" multiple v-model="thingsToSync" :items="possibleThingsToSync" :label="'Configs to import'|translate"></v-select>
                                <editor v-if="!syncInProgress" v-model="syncFromFileJSON" @init="editorInit" lang="json" theme="twilight" width="100%"
                                        height="500"></editor>
                                <v-progress-linear v-if="syncInProgress" :value="syncProgress"></v-progress-linear>
                                <p v-if="syncInProgress" class="text-center">{{ syncMessage }}</p>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn outline class="ml-2" @click="syncFromFileDialog=false" :disabled="syncInProgress">{{ 'Cancel'|translate }}</v-btn>
                                <v-btn class="primary mr-2 elevation-4" :disabled="thingsToSync.length<1||syncInProgress||!syncFromFileJSON||syncFromFileJSON===''" @click="runSyncFromFile">
                                    {{ 'Import from JSON'|translate }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="config"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        :search="search2"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.config_id }}</td>
                            <td class="text-xs-left">
                                {{ props.item.config_name }}
                            </td>
                            <td class="text-xs-left">{{ props.item.facility_name }}</td>
                            <td class="text-xs-left">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Config')"
                                    @click="$can('update', 'Config') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Config')"
                                    @click="$can('update', 'Config') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                    <p v-if="frontendVersion" class="mt-2">
                        {{'Version'|translate}} : {{ frontendVersion }}
                    </p>
                    <p v-if="buildTime" class="mt-2">
                        {{'Build time'|translate}} : {{ buildTime }}
                    </p>
                    <p v-if="apiBaseURL" class="mt-2">
                        API URL : {{ apiBaseURL }}
                    </p>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {
    getConfig,
    deleteConfig,
    getFacilityList,
    putConfig,
    putCustomView,
    getRule,
    putRule,
    getPublishedCustomViews
} from '../helper'
import ConfigRecordDialog from '../components/config/ConfigRecordDialog'
import {mapGetters} from "vuex";
import moment from "moment/moment";
import editor from 'vue2-ace-editor'

export default {
    name: 'Config',
    components: {ConfigRecordDialog,editor},
    data() {
        return {
            dialog: false,
            syncDialog: false,
            syncFromMasterDialog:false,
            syncFromFileDialog:false,
            syncFromFileJSON:'',
            syncProgress: 0,
            syncMessage: null,
            syncInProgress: false,
            possibleThingsToSync:["menuConfig","customViews","rules","mappingIntegrityConfig","mappingIntegritySections","mappingCalculatedConfig","mappingRefConfig","hiddenPointsConfig","chartColorways"],
            thingsToSync:[],
            headers: [
                {
                    text: this.$options.filters.translate('Config ID'),
                    align: 'left',
                    sortable: true,
                    value: 'config_id',
                },
                {text: this.$options.filters.translate('Config Name'), value: 'config_name'},
                {text: this.$options.filters.translate('Facility Name'), value: 'facility_name'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            config: [],
            editedItem: {},
            search: '',
            search2: ''
        }
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    mounted() {
        this.initialize()
    },
    computed: {
        ...mapGetters([
            'apiBaseURL','siteConfigChildren','publishedCustomViews','siteConfigMaster'
        ]),
        frontendVersion() {
            return process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : null
        },
        buildTime(){
            return process.env.VUE_APP_BUILD_TIME
        },
    },
    methods: {
        editorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/json')
            require('brace/theme/twilight')
        },
        async exportAllConfig(){
            this.syncInProgress=true
            let rules = await getRule({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            let configObject={
                customViews:JSON.parse(JSON.stringify(this.publishedCustomViews)),
                rules:rules.result,
                config:{}
            }
            for (let configSyncName of ["menuConfig","mappingIntegrityConfig","mappingIntegritySections","mappingCalculatedConfig","mappingRefConfig","hiddenPointsConfig","chartColorways"]){
                    for (let item of this.config){
                        if (item.config_name===configSyncName){
                            configObject.config[configSyncName]=item
                            break
                        }
                    }
            }
            let file = new Blob([JSON.stringify(configObject, undefined, 3)], {type: 'application/json'});
            let a = document.createElement('a');
            a.href = URL.createObjectURL(file);
            a.download = this.$store.state.pointsListStore.pointsList.facility_name + "- config_export.json";
            a.click();
            this.syncInProgress=false
        },
        async runSyncToChildren(){
            let listOfChildren= this.siteConfigChildren.split(",")
            if (this.thingsToSync.length>0&&listOfChildren.length>0){
                this.syncInProgress=true
                this.syncProgress=0
                this.syncMessage=null
                let progressStep=100/(this.thingsToSync.length*listOfChildren.length)
                let rules=[]
                if (this.thingsToSync.includes("rules")){
                    rules = await getRule({
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name
                    })
                }
                for (let childApiUrl of listOfChildren){
                    let remoteFacilities = await getFacilityList(
                        {
                            apiBaseUrl: childApiUrl
                        }
                    )
                    let remoteConfig = await getConfig(
                        {
                            apiBaseUrl: childApiUrl,
                            facility_name:remoteFacilities.facilities[0].facility_name
                        }
                    )
                    for (let configSyncName of ["menuConfig","mappingIntegrityConfig","mappingIntegritySections","mappingCalculatedConfig","mappingRefConfig","hiddenPointsConfig","chartColorways"]){
                        if (this.thingsToSync.includes(configSyncName)){
                            for (let item of this.config){
                                if (item.config_name===configSyncName){
                                    this.syncMessage="Syncing config "+configSyncName+" to "+remoteFacilities.facilities[0].facility_name
                                    let payload = {
                                        'config_id': null,
                                        'config_name': configSyncName,
                                        'facility_name': remoteFacilities.facilities[0].facility_name,
                                        'config': item.config,
                                        'apiBaseUrl': childApiUrl
                                    }
                                    for (let cfRec of remoteConfig.result) {
                                        if (cfRec.config_name === configSyncName) {
                                            payload.config_id = cfRec.config_id
                                        }
                                    }
                                    await putConfig(payload)
                                    this.syncProgress+=progressStep
                                    break
                                }
                            }
                        }
                    }
                    if (this.thingsToSync.includes("customViews")){
                        this.syncMessage="Syncing custom views to "+remoteFacilities.facilities[0].facility_name
                        let cvs=JSON.parse(JSON.stringify(this.publishedCustomViews))
                        for (let view of cvs){
                            view.facility = remoteFacilities.facilities[0].facility_name
                            view.published = true
                            view.lastUpdated=moment().format('YYYY-MM-DD HH:mm:ss')
                            await putCustomView({
                                view_id:view.id,
                                published:true,
                                json:view,
                                apiBaseUrl: childApiUrl
                            })
                        }
                        this.syncProgress+=progressStep
                    }
                    if (this.thingsToSync.includes("rules")){
                        this.syncMessage="Syncing rules to "+remoteFacilities.facilities[0].facility_name
                        let newRules=JSON.parse(JSON.stringify(rules.result))
                        for (let rule of newRules){
                            rule.facility_name = remoteFacilities.facilities[0].facility_name
                            rule.apiBaseUrl= childApiUrl
                            await putRule(rule)
                        }
                        this.syncProgress+=progressStep
                    }
                }
                this.syncDialog=false
                this.syncInProgress=false
                this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Sync complete')})
            }
        },
        async runSyncFromMaster(){
            if (this.thingsToSync.length>0&&this.siteConfigMaster){
                this.syncInProgress=true
                this.syncProgress=0
                this.syncMessage=null
                let progressStep=100/this.thingsToSync.length
                let remoteFacilities = await getFacilityList(
                    {
                        apiBaseUrl: this.siteConfigMaster
                    }
                )
                let remoteConfig = await getConfig(
                    {
                        apiBaseUrl: this.siteConfigMaster,
                        facility_name:remoteFacilities.facilities[0].facility_name
                    }
                )
                if (this.thingsToSync.includes("customViews")){
                    this.syncMessage="Syncing custom views"
                    let remoteCustomViews = await getPublishedCustomViews(
                        {
                            apiBaseUrl: this.siteConfigMaster,
                            facility_name:remoteFacilities.facilities[0].facility_name
                        }
                    )
                    let cvs=remoteCustomViews.views.map(x=>x.json)
                    for (let view of cvs){
                        view.facility = this.$store.state.pointsListStore.pointsList.facility_name
                        view.published = true
                        await this.$store.dispatch('addUserPlot', view)
                    }
                    this.syncProgress+=progressStep
                }
                for (let configSyncName of ["menuConfig","mappingIntegrityConfig","mappingIntegritySections","mappingCalculatedConfig","mappingRefConfig","hiddenPointsConfig","chartColorways"]){
                    if (this.thingsToSync.includes(configSyncName)){
                        for (let item of remoteConfig.result){
                            if (item.config_name===configSyncName){
                                this.syncMessage="Syncing config "+configSyncName
                                let payload = {
                                    'config_id': null,
                                    'config_name': configSyncName,
                                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                    'config': item.config,
                                }
                                for (let cfRec of this.config) {
                                    if (cfRec.config_name === configSyncName) {
                                        payload.config_id = cfRec.config_id
                                    }
                                }
                                await putConfig(payload)
                                this.syncProgress+=progressStep
                                break
                            }
                        }
                    }
                }
                if (this.thingsToSync.includes("rules")){
                    this.syncMessage="Syncing rules"
                    let remoteRules = await getRule(
                        {
                            apiBaseUrl: this.siteConfigMaster,
                            facility_name:remoteFacilities.facilities[0].facility_name
                        }
                    )
                    for (let rule  of remoteRules.result){
                        delete (rule.facility_id)
                        rule.facility_name = this.$store.state.pointsListStore.pointsList.facility_name
                        await putRule(rule)
                    }
                    this.syncProgress+=progressStep
                }
                this.syncFromMasterDialog=false
                this.syncInProgress=false
                this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Sync complete')})
            }
        },
        async runSyncFromFile(){
            if (this.thingsToSync.length>0&&this.syncFromFileJSON&&this.syncFromFileJSON!==''){
                let configJSON=JSON.parse(this.syncFromFileJSON)
                this.syncInProgress=true
                this.syncProgress=0
                this.syncMessage=null
                let progressStep=100/this.thingsToSync.length
                let remoteConfig = configJSON.config
                if (this.thingsToSync.includes("customViews")){
                    this.syncMessage="Syncing custom views"
                    let remoteCustomViews = configJSON.customViews
                    for (let view of remoteCustomViews){
                        view.facility = this.$store.state.pointsListStore.pointsList.facility_name
                        view.published = true
                        await this.$store.dispatch('addUserPlot', view)
                    }
                    this.syncProgress+=progressStep
                }
                for (let configSyncName of ["menuConfig","mappingIntegrityConfig","mappingIntegritySections","mappingCalculatedConfig","mappingRefConfig","hiddenPointsConfig","chartColorways"]){
                    if (this.thingsToSync.includes(configSyncName)){
                        if (remoteConfig[configSyncName]){
                            this.syncMessage="Syncing config "+configSyncName
                            let payload = {
                                'config_id': null,
                                'config_name': configSyncName,
                                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                                'config': remoteConfig[configSyncName].config,
                            }
                            for (let cfRec of this.config) {
                                if (cfRec.config_name === configSyncName) {
                                    payload.config_id = cfRec.config_id
                                }
                            }
                            await putConfig(payload)
                            this.syncProgress+=progressStep
                        }
                    }
                }
                if (this.thingsToSync.includes("rules")){
                    this.syncMessage="Syncing rules"
                    let remoteRules = configJSON.rules
                    for (let rule  of remoteRules){
                        delete (rule.facility_id)
                        rule.facility_name = this.$store.state.pointsListStore.pointsList.facility_name
                        await putRule(rule)
                    }
                    this.syncProgress+=progressStep
                }
                this.syncFromFileDialog=false
                this.syncInProgress=false
                this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Import complete')})
            }
        },
        initialize() {
            this.refresh()
        },
        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },
        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                await deleteConfig({
                    'config_id': item.config_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getConfig({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            this.config = df['result']
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
    }
}
</script>

<style scoped>

</style>
